import { render, staticRenderFns } from "./favorites-menu.vue?vue&type=template&id=5e4f1522&"
import script from "./favorites-menu.vue?vue&type=script&lang=js&"
export * from "./favorites-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports